export type ReportId = string;
export const toReportId = (reportId: string): ReportId => reportId;
export const fromReportId = (reportId: ReportId): string => reportId;
